import type { CsResolutionMethod } from '@/infrastructure/FulfillmentAdminClient';

/** The ways CS records a resolved issue, in the order the CS team proposed them (SSD-7630). */
export const CS_RESOLUTION_METHODS: ReadonlyArray<{ value: CsResolutionMethod; label: string; hint: string }> = [
  { value: 'reshipment', label: 'Reshipment', hint: '재배송' },
  { value: 'redelivery', label: 'Redelivery', hint: '재배달' },
  { value: 'refunded', label: 'Refunded', hint: '환불 완료' },
];

const LABELS = new Map<string, string>(CS_RESOLUTION_METHODS.map((method) => [method.value, method.label]));

export const isCsResolutionMethod = (value: string): value is CsResolutionMethod => LABELS.has(value);

/** A method this build does not know yet still prints as the server sent it rather than disappearing. */
export const csResolutionMethodLabel = (method: string): string => LABELS.get(method) ?? method;
